//#region Routes
import CancellableHelper from "@/requests/CancellableHelper";
import { Contractor, ContractorBasicInfo, GetContractorResponse } from "@/models/api/Contractor";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { Guid } from "@/static/guid";

export const URL_GET_SELECTED_CONTRACTORS_PAGED = "/Contractor/Selected/Paged";
export const URL_GET_CONTRACTORS_BY_TYPE_PAGED = "/Contractor/${ContractorTypeEnum}/${WithoutLocked}/Paged";
export const URL_GET_CONTRACTOR_CP = "/Contractor/${ContractorId}/Contractors";
export const URL_GET_OFFICE_CONTRACTOR = "/Contractor/OfficeContractor";
export const URL_GET_LOCAL_CONTRACTOR = "/Contractor/${ContractorId}";

export const URL_GET_CONTRACTOR_BY_TIN = "/Contractor/GetByTin";
export const URL_POST_ASSIGN_CONTRACTOR_TO_OFFICE = "/Contractor/AssignContractorToOffice";
//#endregion

export interface SelectedContractorsTableRequest {
  typeEnum: number;
  isInverted: boolean;
  page: number;
  count: number;
  selected: Array<Guid>;
  withoutLocked: boolean;
}

const _getSelectedContractors = new CancellableHelper<GetContractorResponse>(
  URL_GET_SELECTED_CONTRACTORS_PAGED,
  GetContractorResponse
);
export const getSelectedContractors = async (
  selectedContractorsTableRequest: SelectedContractorsTableRequest
): Promise<GetContractorResponse> => {
  return await _getSelectedContractors.get(selectedContractorsTableRequest);
};

const _getContractorsByType = new CancellableHelper<GetContractorResponse>(
  URL_GET_CONTRACTORS_BY_TYPE_PAGED,
  GetContractorResponse
);
_getContractorsByType.jsonSerializer = true;
export const getContractorsByType = async (
  genericTableRequest: GenericTableRequest,
  contractorTypeEnum: number,
  withoutLocked: boolean
): Promise<GetContractorResponse> => {
  return await _getContractorsByType.get({
    ...genericTableRequest,
    WithoutLocked: String(withoutLocked),
    ContractorTypeEnum: contractorTypeEnum,
  });
};

export const getCPContractor = async (contractorId: string): Promise<Contractor> => {
  const _getGDS = new CancellableHelper<Contractor>(URL_GET_CONTRACTOR_CP, Contractor);
  return await _getGDS.get({ ContractorId: contractorId });
};

const _getOfficeContractor = new CancellableHelper<Contractor>(URL_GET_OFFICE_CONTRACTOR, Contractor);
export const getOfficeContractor = async (): Promise<Contractor> => {
  return await _getOfficeContractor.get();
};

const _getLocalContractor = new CancellableHelper<Contractor>(URL_GET_LOCAL_CONTRACTOR, Contractor);
export const getLocalContractor = async (localContractorId: number): Promise<Contractor> => {
  return await _getLocalContractor.get({ ContractorId: localContractorId });
};

const _getContractorByTin = new CancellableHelper<ContractorBasicInfo>(URL_GET_CONTRACTOR_BY_TIN, ContractorBasicInfo);
export const getContractorByTin = async (tin: string): Promise<ContractorBasicInfo> => {
  return await _getContractorByTin.get({ Tin: tin });
};

const _postAssignContractorToOffice = new CancellableHelper<string>(URL_POST_ASSIGN_CONTRACTOR_TO_OFFICE, "string");
export const postAssignContractorToOffice = async (contractorId: string): Promise<string> => {
  return await _postAssignContractorToOffice.get({ ContractorId: contractorId });
};
